<div class="PGTasksView" ngbDropdown [autoClose]="false" (openChange)="onOpenChange($event)" (openChange)="openChange.emit($event)">
    <button class="btn btn-white" ngbDropdownToggle>
        <i class="fa-regular fa-lg fa-tasks opacity-100 m-0"></i>
        <div class="PGTasksView-Badges">
            @if (getUnreadNotificationsCount(); as count) {
                <span class="badge bg-danger m-0 p-1">{{count}}</span>
            }
        </div>
    </button>
    <div class="container-fluid PGTasksView-Menu px-2 py-3 pg-animation-fadein" ngbDropdownMenu>
        @if ((tasks != null && tasks.length > 0) || (remoteJobs != null && remoteJobs.length > 0)) {
            <div class="px-3">
                @for (task of tasks; track task) {
                    <div class="row PGTasksView-Menu-Entry" appPgAnimations="EnterL">
                        <div class="col col-12">
                            <div class="d-flex justify-content-between align-items-center gap-2" title="{{task.name}}{{task.description != null ? ' - ' + task.description : ''}}">
                                <span class="text-truncate">{{task.name}}</span>
                                <span class="flex-shrink-0 small text-muted">{{formatProgressPercent(task.progress, task.status)}}</span>
                            </div>
                            @if (task.description != null) {
                                <small class="text-muted text-truncate d-block">{{task.description}}</small>
                            }
                        </div>
                        <div class="col col-12">
                            <div class="PGTasksView-Menu-Entry-Progress">
                                <div class="progress">
                                    @if (task.status == 'running') {
                                        <div class="progress-bar position-absolute progress-bar-striped progress-bar-animated bg-secondary {{ task.progress != null ? 'opacity-00' : '' }}" role="progressbar">
                                        </div>
                                    }
                                    <div class="progress-bar {{getProgressBarClass(task.status)}}" role="progressbar" [style.transform]="getProgressBarTransform(task.status, task.progress)">
                                    </div>
                                </div>
                            </div>
                        </div>
                        @if (isTaskFinished(task)) {
                            <div class="col col-12 d-flex justify-content-between align-items-center gap-1" appPgAnimations="EnterL">
                                <div class="min-w-0">
                                    @if (getLocalStatusMessage(task); as message) {
                                        <small [class.text-danger]="task.status == 'error'" [class.text-muted]="task.status != 'error'">{{message}}</small>
                                    }
                                </div>
                                <div class="d-flex align-items-center gap-1 flex-shrink-0">
                                    @if (task.status == 'error' && !task.errorFatal) {
                                        <button type="button" class="btn btn-sm btn-link flex-shrink-0 p-0" (click)="redoErrorTask(task)" title="Riprova">
                                            <i class="fa-regular fa-redo"></i>
                                        </button>
                                    }
                                    <button type="button" class="btn btn-sm btn-link flex-shrink-0 p-0" (click)="removeLocalTask(task)">
                                        <i class="fa-regular fa-times"></i> Chiudi
                                    </button>
                                </div>
                            </div>
                        }
                    </div>
                }

                @for (job of remoteJobs; track job.id) {
                    <div class="row PGTasksView-Menu-Entry" appPgAnimations="EnterL">
                        <div class="col col-12">
                            <div class="d-flex justify-content-between align-items-center gap-2" title="{{job.label}}{{job.message != null ? ' - ' + job.message : ''}}">
                                <span class="text-truncate">{{job.label}}</span>
                                <span class="flex-shrink-0 small text-muted">{{formatProgressPercent(getRemoteJobProgress(job), getRemoteUiStatus(job))}}</span>
                            </div>
                        </div>
                        <div class="col col-12">
                            <div class="PGTasksView-Menu-Entry-Progress">
                                <div class="progress">
                                    @if (getRemoteUiStatus(job) == 'running') {
                                        <div class="progress-bar position-absolute progress-bar-striped progress-bar-animated bg-secondary {{ getRemoteJobProgress(job) != null ? 'opacity-00' : '' }}" role="progressbar">
                                        </div>
                                    }
                                    <div class="progress-bar {{getProgressBarClass(getRemoteUiStatus(job))}}" role="progressbar" [style.transform]="getProgressBarTransform(getRemoteUiStatus(job), getRemoteJobProgress(job))">
                                    </div>
                                </div>
                            </div>
                        </div>
                        @if (job.tasks != null && job.tasks.length > 0) {
                            <div class="col col-12">
                                <div class="d-block ms-1 ps-3 border-start w-100">
                                    @for (sub of job.tasks; track $index) {
                                        <div class="d-block mb-2">
                                            <div class="d-flex justify-content-between align-items-center gap-2 small" [class.text-danger]="getRemoteUiStatus(sub) == 'error'" [class.text-muted]="getRemoteUiStatus(sub) != 'error'">
                                                <span class="text-truncate">{{sub.label}}</span>
                                                <span class="flex-shrink-0 small">{{formatProgressPercent(sub.progress, getRemoteUiStatus(sub))}}</span>
                                            </div>
                                            <div class="progress progress-thin w-100 mt-1">
                                                <div class="progress-bar {{getSubProgressBarClass(getRemoteUiStatus(sub))}}" [style.width.%]="(sub.progress || 0) * 100" role="progressbar"></div>
                                            </div>
                                        </div>
                                    }
                                </div>
                            </div>
                        }
                        @if (isRemoteJobFinished(job) || job.message) {
                            <div class="col col-12 d-flex justify-content-between align-items-center gap-1" appPgAnimations="EnterL">
                                <div class="min-w-0">
                                    @if (getRemoteStatusMessage(job); as message) {
                                        <small [class.text-danger]="getRemoteUiStatus(job) == 'error'" [class.text-muted]="getRemoteUiStatus(job) != 'error'">{{message}}</small>
                                    }
                                </div>
                                @if (isRemoteJobFinished(job)) {
                                    <button type="button" class="btn btn-sm btn-link flex-shrink-0 p-0" (click)="removeRemoteJob(job)">
                                        <i class="fa-regular fa-times"></i> Chiudi
                                    </button>
                                }
                            </div>
                        }
                    </div>
                }
            </div>
            <div class="row">
                <div class="col">
                    <hr/>
                </div>
            </div>
        }

        <div class="row PGTasksView-Menu-Notifications">
            <div>
                <app-pg-notification-list></app-pg-notification-list>
            </div>
        </div>
</div>
